// extracted by mini-css-extract-plugin
export var author = "post-module--author--89a8f";
export var body = "post-module--body--f9ad9";
export var commentCount = "post-module--commentCount--91d17";
export var comments = "post-module--comments--0379e";
export var header = "post-module--header--3ef02";
export var highlight = "post-module--highlight--c4db3";
export var hr = "post-module--hr--cc0bd";
export var image = "post-module--image--d3f3a";
export var imageContainer = "post-module--imageContainer--95c73";
export var latestPost = "post-module--latestPost--c5767";
export var pagination = "post-module--pagination--637ad";